import { z } from 'zod';
const idRef = z.string().regex(/^\d+$/, 'Identifikator raqamlardan iborat bo\'lishi kerak');
/** Qo'lda yozilgan lavozim nomi — `position.name` ustuni 150 belgi. */
export const positionNameSchema = z
    .string()
    .trim()
    .min(2, 'Lavozim nomi juda qisqa')
    .max(150, 'Lavozim nomi 150 belgidan oshmasligi kerak');
/** `positionId` va `positionName` BIRGA kelmasligi — ikkala sxemada bir xil. */
const onePosition = (value, ctx) => {
    if (value.positionId !== undefined && value.positionId !== null && value.positionName !== undefined) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['positionName'],
            message: 'Lavozim yo ro\'yxatdan tanlanadi, yo qo\'lda yoziladi',
        });
    }
};
export const employmentSchema = z.object({
    id: z.string(),
    userId: z.string(),
    orgUnitId: z.string(),
    /** Lavozim — NULLABLE: aynan mos lavozim ma'lumotnomada topilmasligi mumkin. */
    positionId: z.string().nullable(),
    /**
     * Korxona ICHIDAGI bo'lim — «R va AX», «TB».
     *
     * NULLABLE: bo'lim biriktirilmagan xodim ham talabnoma yozaveradi va oqim
     * hozirgidek tugaydi — shunchaki bo'linma ombori shakllanmaydi.
     */
    subdivisionId: z.string().nullable(),
    validFrom: z.coerce.date(),
    validTo: z.coerce.date().nullable(),
});
export const createEmploymentSchema = z.object({
    orgUnitId: idRef,
    /**
     * IXTIYORIY: ish joyi lavozimsiz ham tug'iladi.
     *
     * Majburiy bo'lganida kadrlar xodimi bo'linmani biriktirish uchun
     * taxminan bir lavozim tanlashga majbur bo'lardi va o'sha taxmin
     * ekranga haqiqatdek chiqardi.
     */
    positionId: idRef.nullable().optional(),
    /**
     * Lavozim QO'LDA yozilganda — nomi bilan.
     *
     * Ma'lumotnomada aynan mos lavozim ko'pincha topilmaydi, shuning uchun
     * uni shu yerda yozish mumkin: server nomni tozalaydi, ayni shundayi
     * bor-yo'qligini tekshiradi va topilmasa ma'lumotnomaga qo'shadi.
     *
     * `positionId` bilan BIRGA berilmaydi — ikkalasi bo'lsa qaysi biri
     * haqiqiy ekani noaniq qolardi va server jimgina bittasini tanlardi.
     */
    positionName: positionNameSchema.optional(),
    /** Bo'linma AYNAN shu `orgUnitId` ga tegishli bo'lishi tekshiriladi. */
    subdivisionId: idRef.nullable().optional(),
    validFrom: z.coerce.date().optional(),
    validTo: z.coerce.date().nullable().optional(),
}).superRefine(onePosition);
export const updateEmploymentSchema = z.object({
    orgUnitId: idRef.optional(),
    /** `null` — lavozimni BEKOR QILISH; `undefined` — «tegilmasin». */
    positionId: idRef.nullable().optional(),
    /**
     * Lavozim QO'LDA yozilganda — nomi bilan.
     *
     * Ma'lumotnomada aynan mos lavozim ko'pincha topilmaydi, shuning uchun
     * uni shu yerda yozish mumkin: server nomni tozalaydi, ayni shundayi
     * bor-yo'qligini tekshiradi va topilmasa ma'lumotnomaga qo'shadi.
     *
     * `positionId` bilan BIRGA berilmaydi — ikkalasi bo'lsa qaysi biri
     * haqiqiy ekani noaniq qolardi va server jimgina bittasini tanlardi.
     */
    positionName: positionNameSchema.optional(),
    subdivisionId: idRef.nullable().optional(),
    validFrom: z.coerce.date().optional(),
    validTo: z.coerce.date().nullable().optional(),
}).superRefine(onePosition);
//# sourceMappingURL=employment.js.map